// Wipe this device's offline cache, outbox, photos, PDFs, and saved form drafts.
import { cacheClearAll } from "./cache";
import { clearOutboxStore } from "./outbox";
import { clearPdfCache } from "./pdfCache";
import { clearAllLocalPhotos } from "./photos";
import { clearAllPersisted } from "modules/4_final_form/PersistDecorator";

export const clearAllLocalData = async () => {
  await Promise.all([
    cacheClearAll(),
    clearOutboxStore(),
    clearPdfCache(),
    clearAllLocalPhotos(),
    clearAllPersisted(),
  ]);
};
